import { setCookie, getCookie, removeCookie } from './cookies';
import { API_URL } from '../config/api';

const LOCALE_COOKIE_KEY = 'user_locale';

export const LOCALES = {
    EN: 'EN',
    RU: 'RU', 
    ES: 'ES'
};

export const DEFAULT_LOCALE = LOCALES.EN;

// Сохранение локали в куки и памяти
export function saveLocale(locale) {
    if (locale && Object.values(LOCALES).includes(locale)) {
        setCookie(LOCALE_COOKIE_KEY, locale, 30); // Сохраняем на 30 дней
        return locale;
    }
    return DEFAULT_LOCALE;
}

// Получение локали из куки
export function getLocaleFromCookie() {
    const locale = getCookie(LOCALE_COOKIE_KEY);
    if (locale && Object.values(LOCALES).includes(locale)) {
        return locale;
    }
    return null;
}

// Удаление локали из куки
export function removeLocale() {
    removeCookie(LOCALE_COOKIE_KEY);
}

// Проверка актуальной локали с сервера
export async function checkServerLocale(token) {
    if (!token) return null;
    try {
        const response = await fetch(`${API_URL}v2/locale?token=${encodeURIComponent(token)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.ok) {
            const data = await response.json();
            return data.locale;
        }
    } catch (error) {}
    return null;
} 